import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist contour-light py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-244" data-mp="3ksqhhcu0zq9n">
      <div className="mx-auto max-w-6xl px-4" data-id="element-245" data-mp="3fxb4so7r80et">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-246" data-mp="3azjdnwexoibo">
          Testimonios de docentes que ya tienen su Mega Pack
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-247" data-mp="31zd2ih6pjufo">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border-2 border-yellow bg-white p-6 text-ink shadow-card" data-id="element-248" data-mp="2x006b5ty5b0f" data-mpi={index}>
              <div className="flex text-yellow" aria-label="5 de 5 estrellas" data-id="element-249" data-mp="h4n6uketiff5">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-250" data-mp="78aaferw1ngp" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-muted" data-id="element-251" data-mp="c625ghntxpp4">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-4" data-id="element-252" data-mp="zw68onx3vnfl">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-navy text-sm font-extrabold text-white" data-id="element-253" data-mp="14w296d6lgwqe">
                  {initials}
                </span>
                <span data-id="element-254" data-mp="v57nb9x9fz5h">
                  <b className="block text-sm text-ink" data-id="element-255" data-mp="v4o5dt7m1arg">{name}</b>
                  <small className="text-xs text-muted" data-id="element-256" data-mp="1ivk4zcib5a99">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}